import { jsx as _jsx } from "react/jsx-runtime";
import { ICON_NAMESPACE } from './IconSprite';
const Icon = ({ name, raw = false, ...use }) => {
    const href = `#${ICON_NAMESPACE}-${name}`;
    if (raw)
        return _jsx("use", { href: href, ...use });
    return (_jsx("svg", { className: "w-full h-full pointer-events-none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("use", { href: href }) }));
};
export default Icon;
